module.exports = __webpack_public_path__ + "static/qingkai-e96006e460d03be1745a262ac1bb7353.jpg";